import { render, staticRenderFns } from "./CraftIngredient.vue?vue&type=template&id=105d6d6f&scoped=true&"
import script from "./CraftIngredient.vue?vue&type=script&lang=ts&"
export * from "./CraftIngredient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105d6d6f",
  null
  
)

export default component.exports